"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("../../Table.css");
require("./Thead.css");
var Tr_1 = require("../Tr");
var Thead = /** @class */ (function (_super) {
    __extends(Thead, _super);
    function Thead() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Thead.prototype.render = function () {
        return (React.createElement("thead", { "data-test-id": this.props.testId, className: [styles.dataTableHead, this.props.options.className].join(' ') }, this.renderChildren()));
    };
    Thead.prototype.renderChildren = function () {
        var _this = this;
        return React.Children.map(this.props.children, function (child) {
            if (child.type !== Tr_1.default) {
                // tslint:disable-next-line:no-console
                console.error(child.type + " is not allowed child of Thead component");
                return null;
            }
            var trProps = {};
            if (_this.props.events && _this.props.events.onSort) {
                trProps.events = __assign(__assign({}, child.props.events), { onSort: _this.props.events.onSort });
            }
            if (_this.props.options && _this.props.options.collapsible) {
                trProps.options = __assign(__assign({}, child.props.options), { collapsible: _this.props.options.collapsible });
            }
            return React.cloneElement(child, trProps);
        });
    };
    Thead.defaultProps = {
        options: {
            className: '',
        },
    };
    return Thead;
}(React.Component));
exports.default = Thead;
//# sourceMappingURL=Thead.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/containers/Table/components/Thead/Thead.js
// module id = 1371
// module chunks = 8